import * as ReactDOM from 'react-dom/client'
import App from './App'
import './i18n'
import './main.css'

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
